import allRoute from "@/pages/post-saved";
import type { RouteRecordRaw } from "vue-router";

export const postSavedRoutes: RouteRecordRaw = {
  path: "/technician/all-post-saved",
  component: () => import("@/layouts/main.vue"),
  children: [...allRoute]
};
